import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authApi, getToken, setToken, clearToken } from "@/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // undefined = checking, null = not authed, object = authed admin
  const [admin, setAdmin] = useState(undefined);

  const check = useCallback(async () => {
    const t = getToken();
    if (!t) {
      setAdmin(null);
      return;
    }
    try {
      const { data } = await authApi.get("/auth/me");
      setAdmin(data);
    } catch {
      clearToken();
      setAdmin(null);
    }
  }, []);

  useEffect(() => {
    // If returning from Google OAuth, let the callback handler establish the session first
    if (window.location.hash?.includes("session_id=")) {
      setAdmin(null);
      return;
    }
    check();
  }, [check]);

  const loginPassword = async (email, password) => {
    const { data } = await authApi.post("/auth/login", { email, password });
    setToken(data.token);
    setAdmin({ email: data.email, method: data.method, role: "admin" });
    return data;
  };

  const completeGoogle = async (sessionId) => {
    const { data } = await authApi.post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } });
    setToken(data.token);
    setAdmin({ email: data.email, method: "google", role: "admin" });
    return data;
  };

  const logout = async () => {
    try {
      await authApi.post("/auth/logout");
    } catch {
      /* noop */
    }
    clearToken();
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ admin, setAdmin, loginPassword, completeGoogle, logout, refresh: check }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
